import { render } from "./ApproveDenyError.vue?vue&type=template&id=927dfc22"
import script from "./ApproveDenyError.vue?vue&type=script&lang=js"
export * from "./ApproveDenyError.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__